import { useMutation } from '@tanstack/react-query';
import { request } from '../services/request';

export const useAddCM = () => {
  return useMutation(async (data: { organizationId: string; contactId: string; isPrimary: boolean }) => {
    const jsonResponse = await request({
      data,
      method: 'POST',
      endpoint: 'OrgManager/AddCM',
    });

    if (!jsonResponse.success) {
      throw new Error(jsonResponse.data?.Message || 'Something went wrong');
    }

    return jsonResponse;
  });
};

